/**
 * Section Component
 * 
 * Standardized content section with optional dividers.
 * Based on FAQ question/answer pattern.
 */

import type { ReactNode } from 'react';

interface SectionProps {
  title?: string;
  children: ReactNode;
  showDivider?: boolean;
  headingLevel?: 'h2' | 'h3' | 'h4';
  className?: string;
}

export default function Section({ 
  title, 
  children, 
  showDivider = true, 
  headingLevel = 'h2',
  className = '' 
}: SectionProps) {
  const HeadingTag = headingLevel;
  
  const headingStyles = {
    h2: 'text-xl font-bold text-text-primary mb-4',
    h3: 'text-lg font-bold text-text-primary mb-3',
    h4: 'text-base font-bold text-text-primary mb-2',
  }[headingLevel];

  const sectionContent = (
    <div className={className}>
      {title && (
        <HeadingTag className={headingStyles}>
          {title}
        </HeadingTag>
      )}
      <div className="text-text-secondary leading-relaxed space-y-4">
        {children}
      </div>
    </div>
  );

  if (showDivider) {
    return (
      <div className="border-b border-oro-border pb-8">
        {sectionContent}
      </div>
    );
  }

  return (
    <div className="pb-8">
      {sectionContent}
    </div>
  );
}